import React from 'react';
import { Navigate } from 'react-router-dom';
import DataMigrationPage from '../pages/interno/DataMigrationPage';
import { isDataMigrationUiEnabled } from '../services/dataMigrationService';

const getCurrentUserRole = (): number | null => {
  try {
    const raw = localStorage.getItem('userData');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const rol = parsed?.user?.rol ?? parsed?.user?.Rol;
    if (rol === undefined || rol === null) return null;
    if (typeof rol === 'number') return rol;
    return String(rol).toLowerCase() === 'admin' ? 0 : 1;
  } catch {
    return null;
  }
};

/** Ruta oculta: /interno/migracion-datos — no aparece en el menú lateral */
const InternoDataMigrationRoute: React.FC = () => {
  if (!isDataMigrationUiEnabled() || getCurrentUserRole() !== 0) {
    return <Navigate to="/inicio" replace />;
  }

  return <DataMigrationPage />;
};

export default InternoDataMigrationRoute;
